var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", "margin-top": "12px" } },
    [
      _c(
        "el-form",
        { ref: "overallMobileSettingForm", attrs: { size: "mini" } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.mobileSetting.customSetting,
                    callback: function ($$v) {
                      _vm.$set(_vm.mobileSetting, "customSetting", $$v)
                    },
                    expression: "mobileSetting.customSetting",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("panel.mobile_style_setting_tips")))]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            [
              _c(
                "el-radio-group",
                {
                  attrs: {
                    size: "mini",
                    disabled: !_vm.mobileSetting.customSetting,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.onChangeType()
                    },
                  },
                  model: {
                    value: _vm.mobileSetting.backgroundType,
                    callback: function ($$v) {
                      _vm.$set(_vm.mobileSetting, "backgroundType", $$v)
                    },
                    expression: "mobileSetting.backgroundType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "color" } }, [
                    _vm._v(_vm._s(_vm.$t("chart.color"))),
                  ]),
                  _c("el-radio", { attrs: { label: "image" } }, [
                    _vm._v(_vm._s(_vm.$t("panel.photo"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mobileSetting.backgroundType === "color",
                  expression: "mobileSetting.backgroundType==='color'",
                },
              ],
              attrs: { span: 10 },
            },
            [
              _c("el-color-picker", {
                staticClass: "color-picker-custom",
                attrs: {
                  predefine: _vm.predefineColors,
                  size: "mini",
                  disabled: !_vm.mobileSetting.customSetting,
                },
                on: { change: _vm.onChangeType },
                model: {
                  value: _vm.mobileSetting.color,
                  callback: function ($$v) {
                    _vm.$set(_vm.mobileSetting, "color", $$v)
                  },
                  expression: "mobileSetting.color",
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mobileSetting.backgroundType === "image",
                  expression: "mobileSetting.backgroundType==='image'",
                },
              ],
              attrs: { span: 10 },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  class: { disabled: _vm.uploadDisabled },
                  attrs: {
                    action: "",
                    accept: ".jpeg,.jpg,.png,.gif",
                    "list-type": "picture-card",
                    "http-request": _vm.upload,
                    "on-preview": _vm.handlePictureCardPreview,
                    "on-remove": _vm.handleRemove,
                    disabled: !_vm.mobileSetting.customSetting,
                    "file-list": _vm.fileList,
                  },
                },
                [_c("i", { staticClass: "el-icon-plus" })]
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    top: "25vh",
                    width: "600px",
                    "modal-append-to-body": false,
                    visible: _vm.dialogVisible,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogVisible = $event
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mobileSetting.backgroundType === "image",
                  expression: "mobileSetting.backgroundType==='image'",
                },
              ],
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.mobileSetting.imageUrl,
                      expression: "!mobileSetting.imageUrl",
                    },
                  ],
                  staticClass: "image-hint",
                },
                [_vm._v(_vm._s(_vm.$t("panel.panel_background_image_tips")))]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.mobileSetting.imageUrl &&
                        _vm.mobileSetting.customSetting,
                      expression:
                        "mobileSetting.imageUrl && mobileSetting.customSetting",
                    },
                  ],
                  staticClass: "re-update-span",
                  on: { click: _vm.goFile },
                },
                [_vm._v(_vm._s(_vm.$t("panel.reUpload")))]
              ),
            ]
          ),
          _c("input", {
            ref: "files",
            attrs: {
              id: "input",
              type: "file",
              accept: ".jpeg,.jpg,.png,.gif",
              hidden: "",
            },
            on: {
              click: function (e) {
                e.target.value = ""
              },
              change: _vm.reUpload,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }